// src/activities/cape-vr/CAPEVRParent.jsx

import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import CAPEVRForm from './cape-vr-views/CAPEVRForm';
import CAPEVRSession from './cape-vr-views/CAPEVRSession';
import CAPEVRRatings from './cape-vr-views/CAPEVRRatings';
import FullFeedback from '../../components/feedback/FullFeedback';
import useScrollToTop from '../../hooks/useScrolToTop';  // 👈 NOVA LÍNIA 
import { HANDMADE_EVALUATION_TOOL_IDS } from '../../constants/handmadeEvaluationTools';
import NormalizedResponseFeedbackGate from '../../components/application/NormalizedResponseFeedbackGate';
import CapeVrNormalizedFeedback from '../../components/feedback/CapeVrNormalizedFeedback';
import { detectInstrumentResponseFormat } from '../../utils/instrumentResponsePresentation';


function CAPEVRParent({ selectedSample, userRole = "guest", onReset, useCase, renderSample, sampleTaskProvenance, onAssessmentSubmit }) {
  const { t } = useTranslation();
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
  const scrollToTop = useScrollToTop();   

  const [currentStep, setCurrentStep] = useState(null);
  const [submittedData, setSubmittedData] = useState(null);

  const sampleDatabase = selectedSample?.identificationData?.voiceDatabaseId?.databaseName || '';
  const submittedFormat = detectInstrumentResponseFormat(submittedData);

  useEffect(() => {
    if (selectedSample && !currentStep) {
      setCurrentStep("form");
      scrollToTop();  
    }
  }, [selectedSample, currentStep, scrollToTop]);

  const handleNextStep = (nextStep) => {
    setCurrentStep(nextStep);
    scrollToTop();  
  };

  const handleSubmit = (data) => {
    if (onAssessmentSubmit) {
      onAssessmentSubmit(data);
      return;
    }
    if (data?.goBackToSampleSelection) {
      setSubmittedData(null);
      setCurrentStep("form");
    } else {
      setSubmittedData(data);
      setCurrentStep("ratings");
    }
    scrollToTop();  
  };

  const handleRestart = () => {
    if (onReset) onReset();
    else handleNextStep("form");
  };

  return (
    <div className="capevr-container">
      <h1>{t('cape_vr')}</h1>

      {/* 🔹 Formulari */}
      {currentStep === "form" && selectedSample && (
        <CAPEVRForm
          apiUrl={apiUrl}
          selectedSample={selectedSample}
          sampleDatabase={sampleDatabase}
          useCase={useCase}
          renderSample={renderSample}
          sampleTaskProvenance={sampleTaskProvenance}
          onSubmit={handleSubmit}
        />
      )}

      {/* 🔹 Sessió interactiva */}
      {currentStep === "session" && selectedSample && (
        <CAPEVRSession
          apiUrl={apiUrl}
          selectedSample={selectedSample}
        />
      )}

      {/* 🔹 Resultats de l'Avaluació */}
      {currentStep === "ratings" && (
        <CAPEVRRatings
          selectedSample={selectedSample}
          submittedData={submittedData}
          sampleDatabase={sampleDatabase}
          onGoToFeedback={() => handleNextStep("feedback")}
          onRestart={() => handleNextStep("form")}
        />
      )}

      {/* 🔹 Feedback després dels resultats */}
      {currentStep === "feedback" && (
        <NormalizedResponseFeedbackGate assessment={submittedData} provisionalProtocols={['cape-vr']}>
          {submittedFormat.kind === 'normalized' && submittedFormat.protocolKey === 'cape-vr' ? (
            <CapeVrNormalizedFeedback
              apiUrl={apiUrl}
              selectedSample={selectedSample}
              userEvaluation={submittedData}
              onGoToPreview={handleRestart}
            />
          ) : (
            <FullFeedback
              apiUrl={apiUrl}
              selectedSample={selectedSample}
              userEvaluation={submittedData}
              feedbackEvaluationToolId={HANDMADE_EVALUATION_TOOL_IDS.CAPE_VR}
              onGoToPreview={handleRestart}
            />
          )}
        </NormalizedResponseFeedbackGate>
      )}
    </div>
  );
}

export default CAPEVRParent;
